<template>
  <aha-modal @hide="hideModal()" title="Decline invitation">
    <p v-html="content"></p>
    <template #action>
      <aha-button
        variant="danger"
        @click="declineInvitation()"
        has-margin-right
      >
        Decline
      </aha-button>
      <aha-link @click="hideModal()">
        <span>Cancel</span>
      </aha-link>
    </template>
  </aha-modal>
</template>
<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => {},
    },
    handleDecline: {
      type: Function,
      default: () => {},
    },
    content: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      slidesToDelete: [],
    }
  },
  methods: {
    declineInvitation() {
      if (this.handleDecline) {
        try {
          this.handleDecline()
        } catch (e) {
          throw new Error('') // caught inside parent
        }
        this.hideModal()
      }
    },

    hideModal() {
      this.$emit('hide')
    },
  },
}
</script>
